import React, { useEffect, useState } from "react";
import { Case, If } from "~/common/components/If";
import NavbarAndSidebarLayout from "~/layouts/NavbarAndSidebarLayout";
import View from "./View";
import Edit from "./Edit";
import useRequest from "~/common/hooks/useRequest";
import { API_STATE, PAGE_STATE } from "~/common/constants/state";
import LoadingPage from "~/pages/LoadingPage";
import "~/assets/sass/pages/vcMember/vcMember.scss";
import PageHeader from "~/common/components/PageHeader";
import TabMenu from "~/common/components/TabMenu";
import { useGlobalStore } from "~/store";
import { TeamPageIcon } from "~/assets/svg/PageIntroIcon";
import { Trans, useTranslation } from "react-i18next";
import MemberList from "../TeamPage/contents/MemberList";
import AdminTeamPage from "../TeamPage";
import { PlusIcon } from "~/assets/svg/InterfaceIcon";
import AdminAuthPage from "../AuthPage";
import {useParams} from "react-router-dom";

const CompanyMemberPage = () => {
	const { t } = useTranslation();
	const [page, setPage] = useState(PAGE_STATE.LOADING);
	const {tab} = useParams();
	const [
		{
			user: { info },
		},
	] = useGlobalStore();


	const [memberList, setMemberList] = useState([]);
	const [selectUser, setSelectUser] = useState();
	const teamListRequest = useRequest("get", "vc/company/member");

	const [currentTab, setCurrentTab] = useState("team");

	const tabMenuList = info.role === 'admin' ? [
		{ id: "team", title: '팀원 목록' },//translation.t("components.Footer.terms") },
		{ id: "auth", title: '권한 설정' },//translation.t("components.Footer.privacy") },
	] : [
		{ id: "team", title: '팀원 목록' },//translation.t("components.Footer.terms") },
	];

	const [excelData, setExcelData] = useState([]);
	const [error, setError] = useState("");

	const [authEditAlertModal, setAuthEditAlertModal] = useState(false);
	const [authEditAlertContent, setAuthEditAlertContent] = useState(false);
	const [alertState, setAlertState] = useState("");

	useEffect(() => {
		teamListRequest.singleCall();
	}, []);

	useEffect(() => {
		switch (teamListRequest.state) {
			case API_STATE.done:
				setMemberList(teamListRequest.response?.data);
				setPage(PAGE_STATE.VIEW);
				break;
			case API_STATE.loading:
			default:
				break;
		}
	}, [teamListRequest.state]);

	const showViewPage = () => {
		teamListRequest.call();
	};

	const [inviteModal, setInviteModal] = useState(false);

	const headerButtons = [
		<button
			type="button"
			className="btn__solid"
			color="primary"
			onClick={() => setInviteModal(true)}
		>
			팀원 초대
		</button>,
	];


	const buttonList =
		page === PAGE_STATE.VIEW
			? [
				<button
					type="button"
					className="btn__solid"
					color="primary"
					onClick={() => setPage(PAGE_STATE.EDIT)}
				>
					{t("common.commonWord.button.Edit")}
				</button>,
			]
			: selectUser?.role === "admin" // 현재 타겟 유저로 수정하기
				? [
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => {
							setPage(PAGE_STATE.VIEW);
						}}
					>
						{t("pages.myPage.admin.AuthPage.content.btn-back")}
					</button>,
				]
				: [
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => {
							setAuthEditAlertModal(true);
							setAuthEditAlertContent(
								<>
									{selectUser.name}
									{t("pages.myPage.admin.AuthPage.authEditCancel")}
								</>
							);
							setAlertState("cancel");
						}}
					>
						{t("common.commonWord.button.cancel")}
					</button>,
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => {
							setAuthEditAlertModal(true);
							setAuthEditAlertContent(
								selectUser.name + t("pages.myPage.admin.AuthPage.authEditChange")
							);
							setAlertState("submit");
						}}
					>
						{t("common.commonWord.button.apply")}
					</button>,
				];


	useEffect(() => {
		if(tab && info) {
			info.role === "admin" && setCurrentTab("auth");
		}
	}, [tab, info])

	return (
		<>
			<NavbarAndSidebarLayout menu={["vcInfo", "member"]} type="main">
				<PageHeader buttonList={currentTab === 'team' ? headerButtons : buttonList} />
				<div>
					<TabMenu
						tabItem={tabMenuList}
						currentTab={currentTab}
						setCurrentTab={setCurrentTab}
					/>
				</div>
				{
					currentTab === 'team' ?
						<>
							<div className="pageIntro">
								<TeamPageIcon />
								<div className="content">
									<h3>
										<Trans
											i18nKey="pages.myPage.admin.TeamPage.content.h3"
											components={[<b></b>]}
										/>
									</h3>
									<p className="pre">{t("pages.myPage.admin.TeamPage.content.p")}</p>
								</div>
							</div>
							<AdminTeamPage
								showViewPage={showViewPage}
								inviteModal={inviteModal}
								setInviteModal={setInviteModal}
								excelData={excelData}
								setExcelData={setExcelData}
								error={error}
								memberList={memberList}
							/>
						</> :
						<AdminAuthPage
							{...{
								page,
								setPage,
								selectUser,
								setSelectUser,
								// authMemberListRequest,
								// info,
								memberList,
								authEditAlertModal,
								setAuthEditAlertModal,
								authEditAlertContent,
								alertState,
							}
							}
						// authMemberList={memberList}
						/>
				}
				{/* <div>
					<If condition={page} data={memberList} {...{ showViewPage, showEditPage }}>
						<Case condition={PAGE_STATE.VIEW}>
							<View />
						</Case>
						<Case condition={PAGE_STATE.EDIT}>
							<Edit />
						</Case>
						<Case condition={PAGE_STATE.LOADING}>
							<LoadingPage />
						</Case>
					</If>
				</div> */}
			</NavbarAndSidebarLayout>
		</>
	);
};

export default CompanyMemberPage;
